import React, { useCallback } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { UnknownObject } from '../../../../../../react-app-env';

import {
  TextField,
} from '@mui/material';

import { EmergencyRole, ValidationErrors, EmergencyReducerAction, validation } from '../..';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>,
  emergency: EmergencyRole,
  errors: ValidationErrors,
  setErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>,
  dispatch: React.Dispatch<{ type: EmergencyReducerAction, value: any }>,
}

const StepDetails = ({ classes, emergency, errors, setErrors, dispatch }: Props): React.ReactElement => {
  const validate = useCallback((field: string) => {
    const errorItems: UnknownObject = {}
    if (field === 'name') {
      errorItems.name = validation.name(emergency.name);
    }
    setErrors({...errors, ...errorItems});
  }, [emergency, errors, setErrors]);

  return (
    <>
      <div className={classes.root}>
        <TextField
          className={classes.textField}
          data-qa="name-textfield"
          required
          label="Name"
          variant="outlined"
          error={errors.name as boolean}
          helperText={errors.name}
          value={emergency.name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => dispatch({ type: EmergencyReducerAction.NAME, value: event.target.value })}
          onKeyUp={() => validate('name')}
          onBlur={() => validate('name')}/>

        <TextField
          className={classes.textField}
          data-qa="description-textfield"
          label="Description"
          variant="outlined"
          value={emergency.description}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => dispatch({ type: EmergencyReducerAction.DESCRIPTION, value: event.target.value })}/>
          
      </div>
    </>
  );
};

export default withStyles(styles)(StepDetails);
